module.exports = __webpack_public_path__ + "img/ppt.111086c1.svg";